(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9736],{

/***/ 36808:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 69736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_CookieConsent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Container/index.js
var Container = __webpack_require__(30341);
;// CONCATENATED MODULE: ./src/components/FeatureBar/FeatureBar.js




var defaultProps = {
    title: null,
    className: "bg-gradient-to-t from-gray-200 to-white text-gray-900",
    action: null
};
var propTypes = {
    title: (prop_types_default()).string,
    className: (prop_types_default()).string,
    action: (prop_types_default()).node,
    children: (prop_types_default()).node.isRequired
};
function FeatureBar(param) {
    var title = param.title, className = param.className, action = param.action, children = param.children;
    var hasTitle = title !== null;
    var hasAction = action !== null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("fixed left-0 right-0 bottom-0 z-50 shadow-outside", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col space-y-6 py-4 md:flex-row md:items-center md:space-y-0 md:space-x-10 lg:py-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-1 flex-col space-y-2",
                        children: [
                            hasTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-center text-lg font-semibold md:text-left lg:text-xl",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden text-base md:block",
                                children: children
                            })
                        ]
                    }),
                    hasAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex",
                        children: action
                    })
                ]
            })
        })
    });
};
FeatureBar.defaultProps = defaultProps;
FeatureBar.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/FeatureBar/index.js

/* harmony default export */ var components_FeatureBar = (FeatureBar);

// EXTERNAL MODULE: ./src/components/Link/index.js + 2 modules
var Link = __webpack_require__(48300);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./src/hooks/useAcceptCookies.js


var COOKIE_NAME = "accept_cookies";
function useAcceptCookies() {
    var ref = (0,react.useState)(true), acceptedCookies = ref[0], setAcceptedCookies = ref[1];
    (0,react.useEffect)(function() {
        if (!js_cookie_default().get(COOKIE_NAME)) {
            setAcceptedCookies(false);
        }
    }, []);
    var acceptCookies = function() {
        setAcceptedCookies(true);
        js_cookie_default().set(COOKIE_NAME, "accepted", {
            expires: 365
        });
    };
    return {
        acceptedCookies: acceptedCookies,
        onAcceptCookies: acceptCookies
    };
};

;// CONCATENATED MODULE: ./src/components/CookieConsent/CookieConsent.js




function CookieConsent() {
    var ref = useAcceptCookies(), acceptedCookies = ref.acceptedCookies, onAcceptCookies = ref.onAcceptCookies;
    if (acceptedCookies) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FeatureBar, {
        title: "Este sitio web utiliza cookies",
        action: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col space-y-4 md:inline-flex md:w-auto md:flex-row md:items-center md:space-x-3 md:space-y-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    className: "justify-center rounded-full border-2 border-green-500 px-3 py-3 text-center font-semibold leading-4 text-green-600 focus:outline-none focus:ring-2 focus:ring-green-300 md:border-none md:py-2 md:focus:ring-1 md:focus:ring-green-400",
                    href: "/legal/cookies",
                    children: "Pol\xedtica de cookies"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: onAcceptCookies,
                    className: "inline-flex justify-center rounded-full bg-green-600 px-5 py-3 text-center font-semibold leading-5 text-white hover:bg-green-500 focus:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-200 md:py-2",
                    type: "button",
                    children: "De acuerdo"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "font-normal text-gray-700",
            children: "Usamos cookies y otras tecnolog\xedas de seguimiento para mejorar su experiencia de navegaci\xf3n en nuestro sitio web, mostrarle contenido personalizado, analizar el tr\xe1fico de nuestro sitio web y comprender de d\xf3nde provienen nuestros visitantes. Usted acepta nuestro uso de tales cookies y herramientas similares si contin\xfaa utilizando nuestro sitio."
        })
    });
};

;// CONCATENATED MODULE: ./src/components/CookieConsent/index.js

/* harmony default export */ var components_CookieConsent = (CookieConsent);


/***/ })

}]);